module.exports = __webpack_public_path__ + "img/tit2-m.34b49bc4.png";